import React, {Component} from 'react';
import axios from "axios";
import DataTable from "react-data-components/lib/DataTable";
import BaseNavComponent from "../BaseNavComponent";
import NavigationAuth from "../Navigation/NavigationAuth";
import Navigation from "../Navigation";
import * as ROUTES from '../../constants/routes';
import { ClockLoader} from "react-spinners";
import {css} from "@emotion/core";
import filterFactory, {selectFilter,textFilter} from "react-bootstrap-table2-filter";
import BootstrapTable from "react-bootstrap-table-next";
import {BACKEND_BASE_URL} from "../../constants/routes";
import translations from '../Translations'



const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;


const selectOptions = {
    'Lefkosa': 'Lefkosa',
    'Girne' : 'Girne',
    'Magusa': 'Magusa',
    'Lefke': 'Lefke'
};

const houseType = {
    '1+1': '1+1',
    '2+1' : '2+1',
    '3+1': '3+1',
    '4+1': '4+1'
};



class AllJobs extends Component {

    constructor(props) {
        super(props);
        this.state = { jobHistory: [], user: this.props.user,  loading: true}

    }


    columnsForTable = [{
        dataField: 'workerName',
        text: 'Worker Name'
    }, {
        dataField: 'price',
        text: translations.price[this.props.user.language],
        filter: textFilter()
    },
        {
            dataField: 'commission',
            text: translations.commission[this.props.user.language],
            filter: textFilter()
        },

        {
            dataField: 'city',
            text: translations.city[this.props.user.language],
            formatter: cell => selectOptions[cell],
            filter: selectFilter({
                options: selectOptions
            })
        },
        {
            dataField: 'houseType',
            text: translations.house_type[this.props.user.language],
            formatter: cell => houseType[cell],
            filter: selectFilter({
                options: houseType
            })
        },
        {
            dataField: 'date',
            text: translations.date[this.props.user.language]
        },
        {
            dataField: 'wokerphone',
            text: 'Worker phone',
            filter: textFilter()
        },];


    columns = [
        { title: "Worker Name  ", prop : "workerName"},
        { title: translations.price[this.props.user.language], prop : "price"},
        { title: translations.commission[this.props.user.language], prop : "commission"},
        { title: "Worker phone", prop : "wokerphone"},
        { title:  translations.date[this.props.user.language], prop : "convertedDate"}

    ]

    componentDidMount() {
        !this.props.user? this.props.history.push(ROUTES.LOGIN):
            axios.get(`${BACKEND_BASE_URL}/users/allJobs`).then(
                jobHistories=>{
                    let index = 0
                    // console.log(jobHistories.data.data)
                    this.setState({loading:false})
                    jobHistories.data.data.forEach(history=>{
                        history.index = ++index
                    })
                    // console.log(jobHistories.data.data)

                    // let mod = jobHistories.data.data.map(history=>{
                    //     console.log(history.date.__seconds)
                    //     var utcSeconds = history.date.__seconds
                    //     var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
                    //     d.setUTCSeconds(utcSeconds);
                    //         history.date = d.toGMTString()
                    // })
                    // console.log(mod)
                    this.setState({ jobHistory: jobHistories.data.data})

                }
            ).catch(e=>{
                this.setState({loading:false})
                console.log(e)
            })
    }

    render() {
        let data = this.state.jobHistory
        return (
            <div>
                <div className="sweet-loading">
                    <ClockLoader
                        css={override}
                        size={100}
                        //size={"150px"} this also works
                        color={"#123abc"}
                        loading={this.state.loading}
                    />
                </div>

                {/*<DataTable*/}
                {/*    keys="date"*/}
                {/*    columns={this.columns}*/}
                {/*    initialData={data}*/}
                {/*    initialPageLength={5}*/}
                {/*    // initialSortBy={{ prop: 'city', order: 'descending' }}*/}
                {/*/>*/}

                <BootstrapTable keyField='index' data={ data } columns={ this.columnsForTable } filter={ filterFactory() }   striped
                                hover
                                condensed  />


            </div>
        );
    }
}

export default AllJobs;